import React from 'react';

import { YourStaySummaryContainer } from '@/booking/container';
import { AnimatedStack } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';

import { useBooking } from '../hooks';
import BookingCancellationPolicySidebarSectionContainer from './BookingCancellationPolicySidebarSection.container';

interface BookingCheckoutSidebarContainerProps {
  bookingId: string;
  hotelSlug: string;
}

export const BookingCheckoutSidebarContainer = (
  props: BookingCheckoutSidebarContainerProps
) => {
  const booking = useBooking({
    bookingId: props.bookingId,
    hotelSlug: props.hotelSlug,
  });

  const {
    componentProperties: { checkoutSidebar },
  } = useTheme();

  if (!booking) {
    return null;
  }

  return (
    <AnimatedStack
      s={checkoutSidebar?.rowGap}
      css={{ border: checkoutSidebar?.border }}
    >
      <YourStaySummaryContainer
        bookingId={props.bookingId}
        hotelSlug={props.hotelSlug}
      />
      <BookingCancellationPolicySidebarSectionContainer
        bookingId={props.bookingId}
        hotelSlug={props.hotelSlug}
      />
    </AnimatedStack>
  );
};

export default BookingCheckoutSidebarContainer;
